// src/components/DataDeletion.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Status check component to display deletion status
function DeletionStatus() {
  const { code } = useParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  
  useEffect(() => {
    const checkStatus = async () => {
      try {
        // In a real implementation, you would check your database for the status
        // This is a simplified example
        const response = await fetch(`/api/deletion-status?code=${code}`);
        const data = await response.json();
        
        setStatus(data.status);
        setMessage(data.message);
      } catch (error) {
        setStatus('error');
        setMessage('An error occurred while checking your deletion status.');
      }
    };
    
    checkStatus();
  }, [code]);
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Data Deletion Status</h1>
      
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold mb-4">Status: {status}</h2>
        <p>{message}</p>
      </div>
    </div>
  );
}

export default DeletionStatus;